import React from 'react';
import {
  FDListItem,
  FDListItemIcon, FDListItemSecondary, FDListItemText, FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  useEmailTabContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/EmailTabContext';

export const TaskListItem = ({
  actionItemResource,
  isSelected,
  isClientAssigned,
}) => {
  const { handleToggleActionItem, handleClickActionItem } = useEmailTabContext();

  return (
    <FDListItem onClick={() => handleToggleActionItem(actionItemResource, isClientAssigned)}>
      <FDListItemIcon icon={isSelected ? 'checkCircleIcon' : 'circleOutline'} />
      <FDListItemText
        primaryText={actionItemResource.attr('name')}
        secondaryText={actionItemResource.attr('dueDate')}
      />
      <FDListItemSecondary>
        <FDSecondaryActionIconButton
          icon={'edit'}
          onClick={(evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            handleClickActionItem(actionItemResource);
          }}
        />
      </FDListItemSecondary>
    </FDListItem>
  );
};

TaskListItem.propTypes = {
  actionItemResource: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isClientAssigned: PropTypes.bool.isRequired,
};
